// Inherit lib from InTouch CRM
import lib from "@t/fd/Lib";
import type {FormEnvironment} from "./Types";
import {InterfaceRoot, RootLayout} from "@t/fd/InterfaceRoot.ts";

/** Prepare lib to be used by the form */
export default function(script:string|undefined|null, env:FormEnvironment, root:InterfaceRoot<RootLayout>, data:any):any {
    const library:any = {
        ...lib,
        invokeCallParty: (person:number, branch:number, customer:number) => {
            alert("Call interface not yet implemented");
            //ui.invokeCallSheet(person, branch, customer);
        },
        log: (value:any, description?:string):any => {
            console.log((description ? description : "") + ":: " + JSON.stringify(value));
            return value;
        },
        inRole: (role:string):boolean => {
            if (env.user && Array.isArray(env.user.roles)) {
                return env.user.roles.indexOf(role) >= 0;
            }
            return false;
        }
    };

	/** Execute root script */
    if (script) {
        const expose = (key:string, value:any) => library[key] = value;
        const params = ["expose", "env", "f", "g", "r", "lib", script];
        const globalFunction = new Function(...params);
        globalFunction(expose, env, root.content, data, root, library);
    }
    return library;
}